import { importScreen } from '@infrastructure/splitting';

const ReportDetails = importScreen(() => import('./containers'));

export { ReportDetails };
